import styled from 'styled-components';

export const BusinessContent = styled.div`
    margin-left: 0.7rem;
    
    svg{
        font-size: 0.75rem;
    }
`
